export default "__VITE_PUBLIC_ASSET__44e3a83f__"